module.exports = __webpack_public_path__ + "img/hr-puberty-decal-12.a657ba3f.png";